<template>
  <div>
    <v-btn text color="white" to="/support" style="position: relative; top: -50px; float:right;">Looking for support?</v-btn>
    <br class="clear " />
    <div>
      <h1 class="mt-0">We'd love to hear from you!</h1>

      <v-alert type="success" prominent text border="left" icon="fa-user-headset" class="my-6">
        <h3 class="black--text">Book a 30-Minute Demo</h3>
        <p class="black--text">Quickly book a 30-minute demo on the day and time that works best for you.</p>
        <p>
          <v-btn class="gtm-click-demo" large @click="$refs.demoDialog.open()">Book now</v-btn>
        </p>
      </v-alert>

    <div class="mb-4">
      <p class="text-center text-muted">Trusted by over {{ siteData.stats.total_orgs | int }} organizations world-wide:</p>
      <v-slide-group :show-arrows="false" v-model="currentSlideIndex">
        <v-slide-item
          v-for="(item, idx) in siteData.customers.filter(x => x.corporate)"
          :key="idx"
          v-slot="{ active, toggle }"
        >
          <div class="me-4" style="align-content: end; height: 50px;">
            <img :src="`https://sodisp.imgix.net/web/customers/${item.id}-white.png?w=100`" :alt="item.name" class="d-inline-block" :style="`max-width:100px; max-height: 50px; filter:invert(30%);`"/>
          </div>
        </v-slide-item>
      </v-slide-group>      
    </div>

    <v-card color="grey lighten-4 pa-4 mb-16" >
      <h2>Contact Us</h2>
      <p class="mt-2 text-muted"><v-icon x-small class="me-1">fa-question-circle</v-icon> Looking for support? Please <a href="/support">use the support form</a> so we can help you faster.</p>
      <p>Leave a message using the form below, or simply email us at <a :href="`mailto:${tenant.email}`">{{tenant.email}}</a>. We will get back to you within a business day.</p>

      <v-form v-model="valid" ref="contactForm" class="contact-form" action="https://formspree.io/f/mpzknpqw" method="POST">


      <v-row>
          <v-col cols="12" sm="4" class="form-label">My question is about:</v-col>
          <v-col>
            <v-radio-group v-model="topic" name="topic" class="pt-0 mt-0">
              <v-radio value="INQUIRY" label="General inquiry or question" />
              <v-radio value="DEMO" label="Demo request" />
              <v-radio value="START" label="Starting a new event" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="form-label single-row">Name: <span class="red--text">*</span></v-col>
          <v-col>
            <v-text-field
              v-model="name"
              :rules="nameRules"
              label="Your Name"
              name="name"
              required
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="form-label single-row">Organization: <span class="red--text">*</span></v-col>
          <v-col>
            <v-text-field
              v-model="org"
              :rules="orgRules"
              label="Organization Name"
              name="organization"
              required
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="form-label single-row">E-mail: <span class="red--text">*</span></v-col>
          <v-col>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              name="email"
              type="email"
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="form-label single-row">Phone number: <span class="red--text">*</span></v-col>
          <v-col>
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              label="Phone number"
              name="phone"
              type="tel"
              required
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row v-if="false">
          <v-col cols="12" sm="4" class="form-label single-row">Approximate number of participants:</v-col>
          <v-col>
            <v-text-field 
              v-model="participants" 
              label="Approximate number of participants" 
              name="when" 
              hint="How many participants are you expecting for this event? Not sure yet? No worries, a rough guess is good enough!" 
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row v-if="topic == 'DEMO'" >
          <v-col cols="12" sm="4" class="form-label single-row">Demo call date and time preference:</v-col>
          <v-col>
            <v-text-field               
              v-model="meetingDate" 
              label="Demo call date and time preference" 
              name="when" 
              hint="When would you prefer to have this demo? Please include your time zone." 
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row v-if="topic == 'START'">
          <v-col cols="12" sm="4" class="form-label single-row">Start date of event:</v-col>
          <v-col>
            <v-text-field 
              v-model="startDate" 
              label="Start date of event" 
              name="startDate" 
              hint="What is the scheduled start date of your event." 
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="form-label">Message:</v-col>
          <v-col>
            <v-textarea 
              v-model="comments" 
              required 
              label="Your message:" 
              name="comments"
              hint="Tell us about your event. When would you like to start? How many participants are you expecting to join?"
              solo
              persistent-placeholder
              />
          </v-col>
        </v-row>

        <input type="hidden" name="timezone" :value="timeZoneOlson"/>
        <input type="hidden" name="mode" value="Contact Form"/>
        <input type="hidden" name="tenant" :value="tenant.name"/>
      
        <v-row>
          <v-col cols="12" sm="4" class="form-label"></v-col>
          <v-col>
            <v-btn class="primary gtm-track-click" x-large @click="submit('contact', $refs.contactForm)">Submit</v-btn>
          </v-col>
        </v-row>

      </v-form> 
    </v-card>

    </div>
      <multi-step-dialog title="Book a Demo" :step="bookDemoStep" ref="demoDialog" single-step :show-confirm="false">
        <v-stepper-items>
          <v-stepper-content :step="1" class="pa-0">
            <v-row class="my-8 mx-0 align-center" style="justify-content:center;">
              <v-col cols="12" class="mb-0 pb-0">
                <h3 class="mb-0 pb-0">How many participants do you expect to join?</h3>
                <p>If you're not sure yet, just make an educated guess.</p>
              </v-col>
              <v-col cols="12" sm="4">
                <BigButton 
                  elevated 
                  icon="fal fa-users"
                  icon-color="black" 
                  title="Less than 100" 
                  text="" 
                  to="/start-now"
                  />
              </v-col>
              <v-col cols="12" sm="4">
                <BigButton 
                  elevated 
                  icon="fa fa-users"
                  icon-color="black" 
                  title="100 or more" 
                  text="" 
                  to="/r/go/book-demo"
                  />
              </v-col>
            </v-row>
            

          </v-stepper-content>
          <v-stepper-content :step="2" class="">
            <h2>Resources to get started</h2>

          </v-stepper-content>
        </v-stepper-items>
      </multi-step-dialog>
  </div>
</template>


<script>
import siteData from '@/data/site.json'
import { mapGetters } from "vuex";
import { DateTime } from 'luxon'
import { EventBus } from '@/plugins/eventbus.js';
import BigButton from "@/components/BigButton";
import MultiStepDialog from "@/components/generic/MultiStepDialog.vue";
import platformService from "@/services/platformService";
import tenants from '@/data/tenants.config'
const tenant = tenants.current();

export default {
  name: "Contact",
  components: {
    BigButton,
    MultiStepDialog,
  },
  props: {
  },
  data: function() {
    return {
      tenant: tenant,
      siteData: siteData,
      now: DateTime.now(),
      DateTime: DateTime,
      currentSlideIndex: 0,
      interval: 0,
      valid: true,
      mode: 'contact',
      orgSize: null,
      bookDemoStep: 1,
      timeZoneOlson: null,
      participants: '',
      org: '',
      phone: null,
      profileId: null,
      name: null,
      topic: 'INQUIRY',
      startDate: '',
      nameRules: [
        v => !!v || 'Name is required',
      ],
      orgRules: [
        v => !!v || 'Please enter the name of your organization',
      ],
      phoneRules: [
        v => !!v || 'Please enter a phone number where we can reach you',
      ],
      email: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      comments: '',
      meetingDate: '',
    };
  },
  created() {
    var maxIndex = siteData.customers.filter(x => x.corporate).length;
    this.interval = setInterval(() => this.currentSlideIndex > maxIndex ? this.currentSlideIndex = 0 : this.currentSlideIndex++, 2000);
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  async mounted() {
    //this.track();
    this.mode = this.$route.query.mode || this.mode;
    this.name = this.$route.query.name ? this.$route.query.name : null;
    this.email = this.$route.query.email ? this.$route.query.email : null;
    this.comments = this.$route.query.comments ? this.$route.query.comments : null;
    this.timeZoneOlson = DateTime.now().zoneName;
  },
  methods: {
    async submit(formName, form) {
      //console.log('Form submission.', form);
      if (form && form.validate()) {
        try {
          this.$analytics.event('contact_submit', { 'event_category': 'contact', 'event_label': formName });
          this.$analytics.event('generate_lead', {
            currency: 'USD',
            value: 0, // unknown value
          });

          let request = {
            tenant_id: tenant.id,
            name: this.name,
            org: this.org,
            email: this.email,
            phone: this.phone,
            comments: this.comments,
            time_zone: this.timeZoneOlson,
            meeting_date: this.meetingDate,
          };
          let response = await platformService.postForm(formName, request);
          if (response && response.data) {
            this.formResult = response.data;
          }
        }
        catch {}

        form.$el.submit();
      }
    },
    async loadProfile() {
      
    },
    track () {

      //console.log('Tracking event', this.$analytics, 'includes', window.enableAnalyticsProperty);
      //window.disableAnalyticsProperty('UA-163164505-2');
      //window.enableAnalyticsProperty('UA-163164505-2');
      //this.$analytics.query('config', 'UA-163164505-2', {'send_page_view': false});
      //this.$analytics.enableCustomTrackers(this, [ 'UA-163164505-2' ]);
      //this.$analytics.disableCustomTrackers(this);
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
};
</script>

<style scoped lang="scss">
  .contact-form {
    .row .col { padding-top: 0; padding-bottom: 0;}
    .row .form-label { text-align: right; padding-top: 0; }
    .row .form-label.single-row { padding-top: 10px; }
  }
  .v-application.size--xs .contact-form {
    .row .form-label { text-align: left; padding-bottom: 0; padding-top: 0; }
    .row .form-label.single-row { padding-top: 0px; }
  }

</style>